import React from "react";
import { Agency } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";

interface Props {
  agency: Agency;
}

const TrainingCenterAgencyHeader = (props: Props) => {
  return (
    <div className="TrainingCenterAgencyHeader">
      <div className="_logo" style={{ backgroundImage: `url("${props.agency.logoUrl}")` }} />
      <div className="_text">
        <span>{translate(STRINGS.TRAININGS_FOR)}</span>
        <strong>{props.agency.name}</strong>
      </div>
    </div>
  );
};

export default TrainingCenterAgencyHeader;
